// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-WkicnuZR","news":"news-TLf7cPPa","text":"text-20WBAXjc"};